<template>
  <div class="grading-report-transcript">
    <h3>TRANSCRIPT</h3>
    <div class="scroll-content md-scrollbar md-theme-default">
      <div
        v-for="(item, index) in reportItems"
        :key="index"
        :class="{'transcript-item': report.aiTranscriptItems && report.aiTranscriptItems.length }"
      >
        <div v-if="item.type !== 'UNAVAILABLE'" class="item-first-line">
          {{ timestamp(item) }}<span class="item-type"> - {{ typeString[item.type] }}:</span>
        </div>
        <div v-if="item.type !== 'UNAVAILABLE'" class="item-second-line">
          {{ item.label ? item.label : '[No response]' }}
        </div>
        <div v-if="item.type === 'UNAVAILABLE'" class="item-unavailable">
          Not available
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'grading-report-transcript',
  props: {
    report: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      typeString: {
        'QUESTION': 'User Dialogue',
        'ANSWER': 'AI Response',
        'UNAVAILABLE': 'No transcript',
      }
    };
  },
  computed: {
    reportItems() {
      // If there is no transcript, return a placeholder item.  This is necessary because v-if
      // is not working when inside the vue slick component
      return this.report && this.report.aiTranscriptItems && this.report.aiTranscriptItems.length ? this.report.aiTranscriptItems : [
        { timeOf: 0, type: 'UNAVAILABLE', label: 'Transcript not available' }
      ];
    }
  },
  methods: {
    timestamp(item) {
      return `(${Math.floor(item.timeOf / 60).toString().padStart(2, '0')}:${(item.timeOf % 60).toString().padStart(2, '0')})`;
    },
  }
}
</script>

<style scoped>
.grading-report-transcript {
  min-height: 0;
  display: flex !important;
  flex-direction: column;
  flex-grow: 1;
}
.scroll-content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.transcript-item {
  font-size: 14px;
  padding: 5px;
}
.transcript-item:nth-child(odd) {
  background-color: #ededed;
}
.item-type {
  font-weight: 500;
}
.item-first-line {
  margin-bottom: 0px;
}
.item-second-line {
  margin-bottom: 10px;
}
</style>